import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, Select, DatePicker, Modal, message, Input, Table } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assests/styles/base/SubmissionDetails.scss";
import UserData from "utils/UserData";
import { Tenants } from "../../../redux/Actions";
import CommonList from "../../../utils/CommonList/CommonList";
import dayjs from "dayjs";
import CommonFunctions from "../../../utils/CommonFunction/CommonFunctions";
import Headers from "../../../redux/Actions/Headers/Header";
import Spinner from "../../../Components/Spinner/Spiner";
import SelectBox from "../../../Components/SelectBox/SelectBox";

const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);
const startOfMonth = dayjs().startOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
const endOfMonth = dayjs().endOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
const defaultValue = {
    columnFilters:{},
    current: 1,
    pageSize: 10,
    filter: "",
    total: 0,
    sort: "DESC",
    column: "submissionDate",
    startDate: startOfMonth,
    endDate: endOfMonth,
}
const Submissions = () => {
    const { Option } = Select;
    const { RangePicker } = DatePicker;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { locationPagination, timeFilter, searchFilter } = location?.state ?? {};
    const user = UserData();
    const [form] = Form.useForm()
    const [filterForm] = Form.useForm()

    const [paginations, setPagination] = useState(defaultValue);
    const [filterTerm, setFilterTerm] = useState(timeFilter || "thisMonth");
    const [searchTerm, setSearchTerm] = useState(``);
    
    // Initialize from localStorage or location state
    const getInitialSearchTerm = () => {
        if (searchFilter !== undefined) return searchFilter;
        return localStorage.getItem('tenantSubmissionSearch') || '';
    };
    const [showCustomDatePicker, setShowCustomDatePicker] = useState(false);
    const [customRange, setCustomRange] = useState([]);
    const [loading, setIsLoading] = useState(false);
    const response = useSelector((state) => state?.Tenants);
    const submissions = response?.getAllTenants?.data;
    const updateStatusRes = response?.updateTenantById;
    const updatePaymentRes = response?.updatePayment;
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [remark, setRemark] = useState("");
    const [currentSubmissionId, setCurrentSubmissionId] = useState(null);
    const [currentStatus, setCurrentStatus] = useState(null);

    const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Input
                placeholder={`Search ${dataIndex}`}
                value={selectedKeys[0]}
                onChange={(e) =>
                    setSelectedKeys(e.target.value ? [e.target.value] : [])
                }
                onPressEnter={() => {
                    confirm();
                    applyColumnFilter(dataIndex, selectedKeys[0]);
                }}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Button
                type="primary"
                onClick={() => {
                    confirm();
                    applyColumnFilter(dataIndex, selectedKeys[0]);
                }}
                size="small"
                style={{ width: 90, marginRight: 8 }}
            >
                Search
            </Button>
            <Button
                onClick={() => {
                    clearFilters();
                    setSelectedKeys([]); 
                    applyColumnFilter(dataIndex, null);
                }}
                size="small"
                style={{ width: 90 }}
            >
                Reset
            </Button>
        </div>
    ),
    filterIcon: (filtered) => (
        console.log("filtered", filtered),
        <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
                                            stroke="#757575"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
    ),
});

const getColumnSelectProps = (dataIndex, options) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
            <Select
                placeholder={`Select ${dataIndex}`}
                value={selectedKeys[0]}
                style={{ width: 200, marginBottom: 8 }}
                allowClear
                onChange={(value) => {
                    setSelectedKeys(value ? [value] : []);
                }}
            >
                {options.map(opt => (
                    <Select.Option key={opt} value={opt}>
                        {opt}
                    </Select.Option>
                ))}
            </Select>

            <div style={{ display: "flex", gap: 8 }}>
                <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                        confirm();
                        applyColumnFilter(dataIndex, selectedKeys[0]);
                    }}
                >
                    Apply
                </Button>

                <Button
                    size="small"
                    onClick={() => {
                        clearFilters();
                        applyColumnFilter(dataIndex, null);
                    }}
                >
                    Reset
                </Button>
            </div>
        </div>
    ),
    filterIcon: (filtered) => (
        console.log("filtered", filtered),
        <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M14 14L11.1 11.1M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
                                            stroke="#757575"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
    ),
});


const applyColumnFilter = (column, value) => {
    const updatedFilters = {
        ...paginations.columnFilters,
        [column]: value,
    };

    if (!value) delete updatedFilters[column];


    const updatedPagination = {
        ...paginations,
        columnFilters:updatedFilters,
        current: 1, // reset page
    };

    setPagination(updatedPagination);

    GetAllSubmissions(
        updatedFilters,
        updatedPagination.column,
        updatedPagination.sort,
        updatedPagination.current,
        updatedPagination.pageSize,
        updatedPagination.endDate,
        updatedPagination.startDate
    );
};


    const columns = [
        {
            title: "Request ID",
            dataIndex: "id",
            key: "id",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            filteredValue: paginations.columnFilters.id ? [paginations.columnFilters.id] : null,
            ...getColumnSearchProps("id"),
        },
        {
            title: "Actions",
            key: "actions",
            render: (text, record) => (
                <div className="tenant-action-wrap">
                    <Button
                        className="submissions-view-details"
                        onClick={() => {
                            navigate(`./View`, {
                                state: { submissionId: record.id, pagination: paginations, filter: filterTerm, search: searchTerm },
                            })
                        }
                        }
                    >
                        View Details
                    </Button>
                    {(record.paymentStatusName === "Pending" || record.paymentStatusName === "Fail") && (
                        <Button
                            className="submissions-mark-paid"
                            onClick={() => handleMarkIsPaid(record)}
                        >
                            Mark as Paid
                        </Button>
                    )}
                </div>
            ),
        },
        {
            title: "Property Name",
            dataIndex: "propertyName",
            key: "propertyName",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            filteredValue: paginations.columnFilters.propertyName ? [paginations.columnFilters.propertyName] : null,
            ...getColumnSearchProps("propertyName"),
        },
        {
            title: "Submission Date",
            dataIndex: "submissionDate",
            key: "submissionDate",
            defaultSortOrder: "descend",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => CommonFunctions.formatUTCToLocal(text),
        },
        {
            title: "Approval",
            dataIndex: "requestStatusName",
            key: "requestStatusName",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text, record) => {
           
                const filteredOptions = CommonFunctions.approvalOptions?.filter(option => option.label !== text);

                return (
                    <Select
                        value={text}
                        onChange={(value) => showModal(value, record.id)}
                        style={{ width: 120 }}
                    >
                        {filteredOptions?.length > 0 && filteredOptions?.map(option => (
                            <Option key={option.value} value={option.value}>
                                {option.label}
                            </Option>
                        ))}
                    </Select>
                );
            },
            filteredValue: paginations.columnFilters.requestStatusName ? [paginations.columnFilters.requestStatusName] : null,
            ...getColumnSelectProps("requestStatusName", CommonFunctions.approvalOptions.map(option => option.label)),
        },
        {
            title: "Payment",
            dataIndex: "paymentStatusName",
            key: "paymentStatusName",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            filteredValue: paginations.columnFilters.paymentStatusName ? [paginations.columnFilters.paymentStatusName] : null,
            ...getColumnSelectProps("paymentStatusName", CommonFunctions.paymentStatuses.map(option => option.label)),
        },
        {
            title: "Property Address",
            dataIndex: "propertyAddress",
            key: "propertyAddress",
            sorter: true,
            render: (value, record) => `${record?.propertyFullAddress}, ${record?.propertyCity}, ${record?.propertyState}, ${record?.propertyZip}`,
            sortDirections: ['ascend', 'descend', 'ascend'],
            filteredValue: paginations.columnFilters.propertyAddress ? [paginations.columnFilters.propertyAddress] : null,
            ...getColumnSearchProps("propertyAddress"),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            key: "amount",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            render: (text) => (text ? `$${parseFloat(text).toFixed(2)}` : ``),
            filteredValue: paginations.columnFilters.amount ? [paginations.columnFilters.amount] : null,
            ...getColumnSearchProps("amount"),
        },
        {
            title: "Transaction Id",
            dataIndex: ["paymentDetails", "transactionId"],
            key: "transactionId",
            sorter: true,
            sortDirections: ['ascend', 'descend', 'ascend'],
            filteredValue: paginations.columnFilters.transactionId ? [paginations.columnFilters.transactionId] : null,
            ...getColumnSearchProps("transactionId"),
        },
        {
            title: "Submission Type",
            dataIndex: "submissionType",
            key: "submissionType",
            sorter: true,
            render: (value, record) => record?.userId != null ? "Home Owner" : "Non Home Owner",
            sortDirections: ['ascend', 'descend', 'ascend'],
        },
    ];

    const GetAllSubmissions = (columnFilters, sortColumn, sortOrder, pageNumber, pageSize, endDate, startDate) => {
        if (!pageNumber || !pageSize) return;

        let req = {
            request: {
                columnFilters,
                sortColumn,
                sortOrder,
                pageNumber,
                pageSize,
                endDate,
                startDate
            }
        }
        setIsLoading(true);
        dispatch(Tenants.GetAllTenantSubmissionsRequest(req));
    }

    const handleMarkIsPaid = (record) => {
        let request = {
            request: {
                PayaTransactionResponse: null,
                MarkedAsPaid: true,
                MarkedAsPaidBy: user?.getUserInformation()?.displayName,
                TenantId: record?.id
            },
        };
        setIsLoading(true);
        dispatch(Tenants.UpdateTenantPaymentRequest(request))
    }
    const showModal = (status, id) => {
        setCurrentSubmissionId(id);
        setCurrentStatus(status);
        setIsModalVisible(true);
    };

    const handleFilterSubmissions = (e) => {
        const value = e?.target?.value;
        setShowCustomDatePicker(false);
        setCustomRange([]);
        let startDate, endDate;

        switch (value) {
            case "all":
                startDate = null;
                endDate = null;
                break;

            case "thisMonth":
                startDate = startOfMonth;
                endDate = endOfMonth;
                break;

            case "lastMonth":
                startDate = dayjs().subtract(1, "month").startOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
                endDate = dayjs().subtract(1, "month").endOf("month").utc().format("YYYY-MM-DDTHH:mm:ss");
                break;

            case "customRange":
                setShowCustomDatePicker(true);
                return;
        }
        setFilterTerm(value);
            GetAllSubmissions(
                paginations.columnFilters,
                paginations?.column,
                paginations?.sort,
                paginations?.current,
                paginations?.pageSize,
                endDate,
                startDate
            );
            setPagination({
                ...paginations,
                startDate,
                endDate
            })
    };

    const handleApplyCustomRange = () => {
        if (customRange.length === 2) {
            const start = customRange[0].utc().format("YYYY-MM-DDTHH:mm:ss");
            const end = customRange[1].utc().format("YYYY-MM-DDTHH:mm:ss");

            paginations.startDate = start;
            paginations.endDate = end;
            GetAllSubmissions(paginations.columnFilters, paginations.column, paginations.sort, paginations.current, paginations.pageSize, end, start);
        } else {
            message.error({ content: "Please select both start and end dates." });
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const sortOrder = sorter.order === "ascend" ? "asc" : sorter.order === "descend" ? "desc" : null;
        let sortField;
        if (Array.isArray(sorter.field)) {
            sortField = sorter.field[sorter.field.length - 1]; // => 'transactionId'
        } else {
            sortField = sorter.field;
        }
        const sortColumn = sortOrder ? sortField : null;

        setPagination({
            ...paginations,
            sort: sortOrder,
            column: sortColumn,
            current: pagination?.current,
            pageSize: pagination?.pageSize
        });
        GetAllSubmissions(paginations.columnFilters, sortColumn, sortOrder, pagination?.current, pagination?.pageSize, paginations?.endDate, paginations?.startDate)
    };

    const handleOk = () => {
        const approvalBy = user?.getUserInformation()?.displayName;
        let req = {
            id: currentSubmissionId,
            status: currentStatus,
            reason: remark,
            approvalBy: approvalBy
        };
        const request = {
            request: req,
            handle: handleCancel
        };
        setIsModalVisible(false);
        setIsLoading(true);
        dispatch(Tenants.UpdateTenantRequestStatusRequest(request));
    };


    const handleCancel = () => {
        setIsModalVisible(false);
        setRemark("");
    };
    const handleReload = () => {
        // Clear localStorage on page refresh
        localStorage.removeItem('tenantSubmissionSearch');
        navigate(location.pathname, { replace: true });
    };
    
    useEffect(() => {
        // Clear localStorage on component mount if coming from page refresh (no location state)
        if (!locationPagination && !timeFilter && !searchFilter) {
            localStorage.removeItem('tenantSubmissionSearch');
        }
        
        window.addEventListener("beforeunload", handleReload);
        return () => {
            window.removeEventListener("beforeunload", handleReload);
            // Clean up localStorage when component unmounts (navigating away from submissions page)
            if (!location.pathname.includes('TenantRegistrations')) {
                localStorage.removeItem('tenantSubmissionSearch');
            }
        };
    }, []);
    useEffect(() => {
        // Only restore search term if coming from details page (has location state)
        const initialSearch = (locationPagination || timeFilter || searchFilter) ? getInitialSearchTerm() : '';
        
        if (initialSearch) {
            setSearchTerm(initialSearch);
            form.setFieldsValue({ search: initialSearch });
        }
        
        // Restore pagination state when coming back from details
        if (locationPagination && Object.keys(locationPagination)?.length > 0) {
            console.log(locationPagination,"locationPagination")
            setPagination(locationPagination);
            // Fetch data with restored pagination
            GetAllSubmissions(
                locationPagination?.columnFilters, 
                locationPagination?.column, 
                locationPagination?.sort, 
                locationPagination?.current, 
                locationPagination?.pageSize, 
                locationPagination?.endDate, 
                locationPagination?.startDate
            );
        } else {
            // Fresh load - use default pagination
            GetAllSubmissions(
                paginations?.columnFilters, 
                paginations?.column, 
                paginations?.sort, 
                paginations?.current, 
                paginations?.pageSize, 
                paginations?.endDate, 
                paginations?.startDate
            );
        }
    }, [])

    useEffect(() => {
        dispatch(
            Headers.setHeader({
                title: "Tenant Registration",
            })
        );
        return () => dispatch(Headers.resetHeader());
    }, [dispatch]);


    useEffect(() => {
        if (submissions) {
            setIsLoading(false);
        }
        if (submissions?.totalCount > 0) {
            // Only update total count, preserve other pagination state
            setPagination((prev) => ({
                ...prev,
                total: submissions?.totalCount,
            }));
        }
    }, [submissions]);
    useEffect(() => {
        if (updatePaymentRes && Object.keys(updatePaymentRes).length > 0) {
            if (updatePaymentRes?.status) {
                dispatch(Tenants.UpdateTenantPaymentSuccess({}))
                message.success({ content: "Payment marked as paid." });
                GetAllSubmissions(paginations.columnFilters, paginations.column, paginations.sort, paginations.current, paginations.pageSize, paginations.endDate, paginations.startDate);
            } else {
                message.error({ content: "The payment status could not be updated. Please try again." })
            }
            setIsLoading(false);
        }
    }, [updatePaymentRes]);

    useEffect(() => {
        if (updateStatusRes && Object.keys(updateStatusRes).length > 0) {
            if (updateStatusRes?.status) {
                dispatch(Tenants.UpdateTenantRequestStatusSuccess({}))
                message.success({ content: "Status changed successfully." });
                GetAllSubmissions(paginations.columnFilters, paginations.column, paginations.sort, paginations.current, paginations.pageSize, paginations.endDate, paginations.startDate);
            } else {
                message.error({ content: "The status could not be updated. Please try again." })
            }
            setIsLoading(false);
        }
    }, [updateStatusRes]);
    return (
        <>
            {(loading) && <Spinner />}
            <div className="d-flex justify-content-between page-header-wrap">
                <div className="header-filter-wrapper filterContainer">
                    <div className="header-filter-wrap filter-date-container">
                        <Form form={filterForm} className="filterSubmission" initialValues={{ filterBy: timeFilter ? timeFilter : filterTerm }}>
                            <SelectBox
                                label=""
                                name="filterBy"
                                placeholder="Filter By"
                                size="large"
                                showSearch
                                options={CommonList.filterOptions}
                                onChange={handleFilterSubmissions}
                            />
                        </Form>
                        {showCustomDatePicker && (
                            <div direction="vertical" className="datepicker-container">
                                <RangePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                    onChange={(values) => setCustomRange(values)}
                                    value={customRange}
                                />
                                <Button type="primary" className="apply-btn" onClick={handleApplyCustomRange}>
                                    Submit
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Table 
                columns={columns} 
                scroll={{ x: 'max-content' }} 
                dataSource={submissions?.tenantRegistrations ?? []} 
                onChange={handleTableChange} 
                pagination={submissions?.tenantRegistrations?.length > 0 ? {
                    current: paginations.current,
                    pageSize: paginations.pageSize,
                    total: paginations.total,
                    showSizeChanger: true,
                } : false} 
            />
            <Modal
                title={`Enter Remark (if any).`}
                open={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText="Submit"
                cancelText="Cancel"
            >
                <Input.TextArea
                    rows={4}
                    value={remark}
                    onChange={(e) => setRemark(e.target.value)}
                    placeholder="Please enter your remark"
                    required={true}
                />
            </Modal>

        </>)

};

export default Submissions;
